import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronRight, CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import Icon from "@/components/IconMap";
import api from "@/lib/api";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setS(null); api.get(`/services/${slug}`).then((r) => setS(r.data)).catch(() => setNf(true)); }, [slug]);
  if (nf) return <PublicLayout><div className="pt-40 pb-20 text-center"><h1 className="font-display text-2xl font-bold">Service not found</h1><Link to="/services" className="text-brand-emerald mt-4 inline-block">← All services</Link></div></PublicLayout>;
  if (!s) return <PublicLayout><div className="pt-40 grid place-items-center"><div className="h-10 w-10 rounded-full border-2 border-brand-emerald border-t-transparent animate-spin" /></div></PublicLayout>;

  return (
    <PublicLayout waMessage={`Hi Dreamzz HR & Consultancy, I would like to know more about ${s.name}.`}>
      <Seo title={s.seo_title || s.name} description={s.meta_description || s.short}
        schema={breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Services", url: "/services" }, { name: s.name, url: window.location.href }])} />
      <PageHeader eyebrow="Service">
        <div className="flex items-start gap-4">
          <span className="grid place-items-center h-14 w-14 rounded-2xl bg-brand-emerald/15 text-brand-emerald shrink-0"><Icon name={s.icon} size={26} /></span>
          <div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{s.name}</h1>
            <p className="text-slate-400 mt-3 max-w-2xl">{s.short}</p>
          </div>
        </div>
      </PageHeader>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <p className="text-slate-300 leading-relaxed text-lg">{s.description}</p>
        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          {["Verified candidate database", "Structured screening process", "Fast turnaround across Karnataka", "Dedicated recruiter support"].map((t) => (
            <div key={t} className="glass rounded-xl p-4 flex items-center gap-3"><CheckCircle2 size={18} className="text-brand-emerald" /><span className="text-sm">{t}</span></div>
          ))}
        </div>
        <div className="mt-10 glass-strong rounded-2xl p-8 text-center">
          <h3 className="font-display text-2xl font-bold">Need {s.name}?</h3>
          <p className="text-slate-400 mt-2">Talk to our recruitment team and get started today.</p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Link to="/for-employers"><Button className="bg-brand-emerald hover:bg-[#C62828] text-white font-semibold">Submit Hiring Requirement <ArrowRight size={16} className="ml-2" /></Button></Link>
            <Link to="/contact"><Button variant="outline" className="border-white/15">Contact Us</Button></Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
